@if (isLoaded()) {
  <app-loading-indicator [isLoading]="loadingServiceIsLoading"></app-loading-indicator>
  <div class="Flexbox Flexbox--column Justify--space-between AttributeContent">
    <div class="PreviewerContainer">
      <app-previewer [isSharing]="true" class="Previewer"></app-previewer>
    </div>
    <app-checkout-summary [skuToShowOverride]="sku()" [isSharing]="true"></app-checkout-summary>
  </div>
} @else {
  <app-loading-indicator [isLoading]="true"></app-loading-indicator>
}
